const pickupActivityActions = {
  SEARCH_PICKUP_ACTIVITIES: 'SEARCH_PICKUP_ACTIVITIES',
  SEARCH_PICKUP_ACTIVITIES_ENDED: 'SEARCH_PICKUP_ACTIVITIES_ENDED',
  CREATE_PICKUP_ACTIVITY: 'CREATE_PICKUP_ACTIVITY',
  CREATE_PICKUP_ACTIVITY_ENDED: 'CREATE_PICKUP_ACTIVITY_ENDED',
  FIND_PICKUP_ACTIVITY: 'FIND_PICKUP_ACTIVITY',
  FIND_PICKUP_ACTIVITY_ENDED: 'FIND_PICKUP_ACTIVITY_ENDED',
  UPDATE_PICKUP_ACTIVITY: 'UPDATE_PICKUP_ACTIVITY',
  UPDATE_PICKUP_ACTIVITY_ENDED: 'UPDATE_PICKUP_ACTIVITY_ENDED',
  DELETE_PICKUP_ACTIVITIES: 'DELETE_PICKUP_ACTIVITIES',
  DELETE_PICKUP_ACTIVITIES_ENDED: 'DELETE_PICKUP_ACTIVITIES_ENDED',

  SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS: 'SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS',
  SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS_ENDED:
    'SEARCH_PICKUP_ACTIVITY_TRANSACTION_RECORDS_ENDED',

  GET_PICKUP_ACTIVITY_STATISTICS: 'GET_PICKUP_ACTIVITY_STATISTICS',
  GET_PICKUP_ACTIVITY_STATISTICS_ENDED: 'GET_PICKUP_ACTIVITY_STATISTICS_ENDED',

  SEARCH_PICKUP_CODE_BATCH: 'SEARCH_PICKUP_CODE_BATCH',
  SEARCH_PICKUP_CODE_BATCH_ENDED: 'SEARCH_PICKUP_CODE_BATCH_ENDED',
  SEARCH_PICKUP_CODE_BATCH_ROW: 'SEARCH_PICKUP_CODE_BATCH_ROW',
  SEARCH_PICKUP_CODE_BATCH_ROW_ENDED: 'SEARCH_PICKUP_CODE_BATCH_ROW_ENDED',
  ISSUE_PICKUP_ACTIVITY_PICKUP_CODE: 'ISSUE_PICKUP_ACTIVITY_PICKUP_CODE',
  ISSUE_PICKUP_ACTIVITY_PICKUP_CODE_ENDED: 'ISSUE_PICKUP_ACTIVITY_PICKUP_CODE_ENDED',
  INVALIDATE_PICKUP_CODES_BATCH: 'INVALIDATE_PICKUP_CODES_BATCH',
  INVALIDATE_PICKUP_CODES_BATCH_ENDED: 'INVALIDATE_PICKUP_CODES_BATCH_ENDED',
  INVALIDATE_PICKUP_CODES_BATCH_ROW: 'INVALIDATE_PICKUP_CODES_BATCH_ROW',
  INVALIDATE_PICKUP_CODES_BATCH_ROW_ENDED: 'INVALIDATE_PICKUP_CODES_BATCH_ROW_ENDED',

  PICKUP_ACTIVITY: 'PICKUP_ACTIVITY',
  PICKUP_ACTIVITY_ENDED: 'PICKUP_ACTIVITY_ENDED',

  SEARCH_PICKUP_ACTIVITY_CATEGORIES: 'SEARCH_PICKUP_ACTIVITY_CATEGORIES',
  SEARCH_PICKUP_ACTIVITY_CATEGORIES_END: 'SEARCH_PICKUP_ACTIVITY_CATEGORIES_END',
  CREATE_PICKUP_ACTIVITY_CATEGORY: 'CREATE_PICKUP_ACTIVITY_CATEGORY',
  CREATE_PICKUP_ACTIVITY_CATEGORY_END: 'CREATE_PICKUP_ACTIVITY_CATEGORY_END',
  UPDATE_PICKUP_ACTIVITY_CATEGORY: 'UPDATE_PICKUP_ACTIVITY_CATEGORY',
  UPDATE_PICKUP_ACTIVITY_CATEGORY_END: 'UPDATE_PICKUP_ACTIVITY_CATEGORY_END',
  DELETE_PICKUP_ACTIVITY_CATEGORIES: 'DELETE_PICKUP_ACTIVITY_CATEGORIES',
  DELETE_PICKUP_ACTIVITY_CATEGORIES_END: 'DELETE_PICKUP_ACTIVITY_CATEGORIES_END',
  FIND_PICKUP_ACTIVITY_CATEGORY: 'FIND_PICKUP_ACTIVITY_CATEGORY',
  FIND_PICKUP_ACTIVITY_CATEGORY_END: 'FIND_PICKUP_ACTIVITY_CATEGORY_END',

  SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES: 'SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES',
  SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES_ENDED:
    'SEARCH_MEMBER_TICKET_ISSUED_AND_ACTIVITIES_ENDED',
  SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES: 'SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES',
  SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES_ENDED:
    'SEARCH_MEMBER_TICKET_DETAILS_AND_ACTIVITIES_ENDED',
};

export default pickupActivityActions;
